import {
  IonBackButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonList,
  IonLoading,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter,
} from '@ionic/react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import SongItem from '../components/SongItem';
import { useSongs } from '../data/store/useSongs';
import { useIdParam, usePageTitle } from '../util/sugar';


const SongRevisions: React.FC = (props) => {
  const id = useIdParam(props);
  const history = useHistory();
  const { fetchRevisions, status } = useSongs();
  const revisions = useSongs(x => x.revisions);

  useEffect(() => {
    fetchRevisions(id);
  }, [fetchRevisions, id]);

  useIonViewWillEnter(() => {
    // Read from history (always current) rather than the closure value of `id`,
    // which can be stale when Ionic re-activates a cached page with a new param.
    const currentId = history.location.pathname.split('/').pop();
    if (currentId) fetchRevisions(currentId);
  });

  usePageTitle('Revisions');

  const isLoading = status === 'fetching';
  const isEmpty = !isLoading && revisions.length === 0;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>Revision History</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="sadfam-content">
        <IonLoading isOpen={isLoading} />
        <IonGrid>
          <IonRow>
            <IonCol sizeMd="8" sizeLg="6" offsetMd="2" offsetLg="3">
              {isEmpty && (
                <IonText color="medium">
                  <p style={{ textAlign: 'center', padding: '2rem' }}>No revision history found.</p>
                </IonText>
              )}
              <IonList>
                {revisions.map(revision => (
                  <SongItem key={revision.id} id={revision.id} />
                ))}
              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default SongRevisions;
